import { quoteEditModeCompatibleRoutesSlugs, quoteRoutes } from '~/components/quote/consts';
import { QuoteContext } from '~/types/quote';

export const cleanValue = (value: string): number => {
  return +value.replace(/,/g, '.').split('.').slice(0, 2).join('.');
};

export const roundToSecondDecimal = (value: number): number => {
  return Math.round((value + Number.EPSILON) * 100) / 100;
};

const isQuoteRoute = (path: string): boolean => {
  return quoteRoutes.some((route) => path.includes(route));
};

const isQuoteCompatibleRoute = (path: string): boolean => {
  return quoteEditModeCompatibleRoutesSlugs.some((route) => path.includes(route));
};

export const setQuoteContext = (from: string, to: string, currentContext: QuoteContext): QuoteContext => {
  if (isQuoteRoute(from) && isQuoteCompatibleRoute(to)) {
    return 'external';
  }

  if (currentContext === 'external' && isQuoteCompatibleRoute(from) && isQuoteCompatibleRoute(to)) {
    return 'external';
  }

  if (isQuoteRoute(to)) return 'quote';

  return 'normal';
};

export const onKeyDown = (event: KeyboardEvent, preventDecimals = false) => {
  handleKeyRestrictions(event, { allowedKeys: preventDecimals ? [] : [',', '.'], allowLetter: false });
};
interface Step {
  key: string;
  slots: Record<string, string>;
}

export const steps: Step[] = [
  {
    key: 'step_0',
    slots: {
      foretags: 'företags-',
      och: 'och',
      kundinformation: 'kundinformation',
    },
  },
  {
    key: 'step_1',
    slots: {
      Valj: 'Välj',
      produkter: 'produkter',
      bilagor: 'bilagor',
    },
  },
  {
    key: 'step_2',
    slots: {
      Anpassa: 'Anpassa',
      priser: 'priser',
      bilagor: 'bilagor',
    },
  },
  {
    key: 'step_3',
    slots: {
      Skicka: 'Skicka',
      direkt: 'direkt',
      till: 'till',
      kund: 'kund',
      PDF: 'PDF',
    },
  },
  {
    key: 'step_4',
    slots: {
      Skapa: 'Skapa',
      en: 'en',
      varukorg: 'varukorg',
    },
  },
];
